import React, { useEffect, useState } from "react";
import Form, {
  SimpleItem, GroupItem, Label, RequiredRule, ButtonItem, ButtonOptions, TabbedItem, TabPanelOptions, Tab
} from 'devextreme-react/form';
import { LVForm } from "../Basicos/LVForm";
import ComboAbmZonEmpresas from "../Compuestos/Combos/ComboAbmZonEmpresas";
import {
  function_ABM_ZON_Plantas_ModificarLogo
} from "neftis7_apicaller/src/funciones/ABM/ZON/ABM_ZON_Plantas";
import { function_base64ToHex } from "../../funciones/Varios";
import LVButtonAccion from "../Basicos/LVButtonAccion";
import { function_ABM_IMP_Terminales_Generar_JSON, function_ABM_IMP_Terminales_Insertar, function_ABM_IMP_Terminales_Leer, function_ABM_IMP_Terminales_Modificar } from "neftis7_apicaller/src/funciones/ABM/IMP/ABM_IMP_Terminales";

const ABM_IMP_Terminales = (props) => {
  const [datos, setDatos] = useState([]);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [esModificacion, setEsModificacion] = useState(false);
  const [imagenLogoBase64, setImagenLogoBase64] = useState(null);
  const [imagenLogoPreview, setImagenLogoPreview] = useState(null);

  const handleOnClick_Guardar = async (e) => {
    try {

      const JSON = await function_ABM_IMP_Terminales_Generar_JSON(
        datos.CodigoTerminal,
        localStorage.getItem("CodigoCompania"),
        localStorage.getItem("CodigoEmpresa"),
        localStorage.getItem("CodigoPlanta"),
        datos.Descripcion,
        datos.CodigoCuentaFinancieraEfectivoCaja,
        datos.CodigoCuentaFinancieraEfectivoRetiros,
        datos.VerificacionSaldoObligatoriaEnApertura,
        datos.VerificacionSaldoObligatoriaEnCierre,
        datos.FechaUltimaCargaSaldoApertura,
        datos.FechaUltimaCargaSaldoCierre,
        datos.ImporteUltimoSaldoAperturaEfectivo,
        datos.ImporteFaltanteSaldoAperturaEfectivo,
        datos.ImporteSobranteSaldoAperturaEfectivo,
        datos.ImporteUltimoSaldoCierreEfectivo,
        datos.ImporteUltimoSaldoCierreCredito,
        datos.ImporteUltimoSaldoCierreDebito,
        datos.CodigoUbicacionStockDeVenta,
        datos.CodigoUbicacionStockDeReposicion,
        datos.VerificacionStockObligatoriaEnApertura,
        datos.VerificacionStockObligatoriaEnCierre,
        datos.FechaUltimaVerificacionStockApertura,
        datos.FechaUltimaVerificacionStockCierre,
        datos.PuntoVentaSePuedenModificarPrecios,
        datos.PuntoVentaConTurno,
        datos.UltimoTurnoAbierto,
        datos.FechaDeTicketEsFechaDeApertura,
        datos.ImporteEfectivoEnCajaAviso,
        datos.ImporteEfectivoEnCajaCorte,
        datos.HoraDesdeLaCualSalteaPrimerTurno,
        datos.VerificacionStockSecundariaObligatoriaEnApertura,
        datos.VerificacionStockSecundariaObligatoriaEnCierre,
        datos.FechaUltimaVerificacionStockSecundariaApertura,
        datos.FechaUltimaVerificacionStockSecundariaCierre,
        datos.InformaCierres_NoInformaTickets,
        datos.VerificacionStockTerciariaObligatoriaEnApertura,
        datos.VerificacionStockTerciariaObligatoriaEnCierre,
        datos.FechaUltimaVerificacionStockTerciariaApertura,
        datos.FechaUltimaVerificacionStockTerciariaCierre,
        datos.UltimaVersionIngresada,
        datos.UltimaVersionIngresadaNumerica,
        datos.PasswordBonificaciones,
        datos.HabilitacionRetiroFraccionado,
        datos.HabilitacionTabDetalleBotones,
        datos.HabilitacionTabDetalleListado,
        datos.HabilitacionTabClientes,
        datos.HabilitacionTabPago,
        datos.HabilitacionTabImagenes,
        datos.HabilitacionTabAdministracion,
        datos.HabilitacionBotonRemitoTransferencia,
        datos.HabilitacionBotonMerma,
        datos.HabilitacionBotonConsumo,
        datos.HabilitacionBotonCheque,
        datos.HabilitacionControlesEnvio,
        datos.HabilitacionControlesArticuloPorCodigo,
        datos.HabilitacionBotonRemitoVenta,
        datos.HabilitacionTabDetalleBotonesSecundario,
        datos.PorcentajeDescuentoMaximo,
        datos.HabilitacionBotonRecepcion,
        datos.HabilitacionTabProveedores,
        datos.CodPOSExterno,
        datos.CodigoAgrupacion,
        datos.InterfazIRSA,
        datos.CodigoCuentaFinancieraRappi,
        datos.SiempreTicketFraccionado,
        datos.TieneImpresoraFiscal,
        datos.GeneraDocsVentaExcluidosDeHojaDeRuta,
        datos.PermiteDocumentosAbiertos,
        datos.DocumentosAbiertosSonMesas,
        datos.SolicitaVendedorAlCerrarOperacion,
        datos.VentasPVProveedorDelivery1,
        datos.VentasPVProveedorDelivery2,
        datos.VentasPVProveedorDelivery3,
        datos.VentasPVProveedorDelivery4,
        datos.VentasPVProveedorDelivery5,
        datos.VentasPVProveedorDelivery6,
        datos.VentasPVProveedorDelivery1Activo,
        datos.VentasPVProveedorDelivery2Activo,
        datos.VentasPVProveedorDelivery3Activo,
        datos.VentasPVProveedorDelivery4Activo,
        datos.VentasPVProveedorDelivery5Activo,
        datos.VentasPVProveedorDelivery6Activo,
        datos.VentasPVProveedorDelivery1CantidadDigitos,
        datos.VentasPVProveedorDelivery2CantidadDigitos,
        datos.VentasPVProveedorDelivery3CantidadDigitos,
        datos.VentasPVProveedorDelivery4CantidadDigitos,
        datos.VentasPVProveedorDelivery5CantidadDigitos,
        datos.VentasPVProveedorDelivery6CantidadDigitos,
        datos.VentasPVProveedorDelivery1CuentaFinanciera,
        datos.VentasPVProveedorDelivery2CuentaFinanciera,
        datos.VentasPVProveedorDelivery3CuentaFinanciera,
        datos.VentasPVProveedorDelivery4CuentaFinanciera,
        datos.VentasPVProveedorDelivery5CuentaFinanciera,
        datos.VentasPVProveedorDelivery6CuentaFinanciera,
        datos.VentasPVProveedorDelivery1ListaDePrecios,
        datos.VentasPVProveedorDelivery2ListaDePrecios,
        datos.VentasPVProveedorDelivery3ListaDePrecios,
        datos.VentasPVProveedorDelivery4ListaDePrecios,
        datos.VentasPVProveedorDelivery5ListaDePrecios,
        datos.VentasPVProveedorDelivery6ListaDePrecios,
        datos.TerminalParaControlDeExpedicion,
        datos.HabilitacionTabReservas
      )

      if (props.Codigo.Codigo === "--NUEVO--") {

        const Creado = await function_ABM_IMP_Terminales_Insertar(JSON)

        alert("Se ha generado el Código: " + Creado.data.codigoGenerado)
      } else {

        const Modificado = await function_ABM_IMP_Terminales_Modificar(JSON)

        alert("Se ha modificado el Código: " + datos.CodigoPlanta)
      }

      window.location.reload()
    } catch (error) {
      alert(error)
    }
  }

  const handleOnClick_GuardarImagenLogo = async (e) => {
    try {
      const logoHex = function_base64ToHex(imagenLogoBase64);

      await function_ABM_ZON_Plantas_ModificarLogo(props.Codigo.Codigo, logoHex);
      alert("Logo guardado correctamente");
    } catch (error) {
      alert("Error al guardar el logo");
      console.error(error);
    }
  };

  const handleImagenLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagenLogoPreview(reader.result); // Vista previa
        setImagenLogoBase64(reader.result.split(",")[1]); // Guardar solo la parte Base64
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {

    const getData = async () => {
      try {
        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")

          setDatos({
            CodigoTerminal: 0,
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            Descripcion: '',
            CodigoCuentaFinancieraEfectivoCaja: '',
            CodigoCuentaFinancieraEfectivoRetiros: '',
            VerificacionSaldoObligatoriaEnApertura: false,
            VerificacionSaldoObligatoriaEnCierre: false,
            FechaUltimaCargaSaldoApertura: '',
            FechaUltimaCargaSaldoCierre: '',
            ImporteUltimoSaldoAperturaEfectivo: 0,
            ImporteFaltanteSaldoAperturaEfectivo: 0,
            ImporteSobranteSaldoAperturaEfectivo: 0,
            ImporteUltimoSaldoCierreEfectivo: 0,
            ImporteUltimoSaldoCierreCredito: 0,
            ImporteUltimoSaldoCierreDebito: 0,
            CodigoUbicacionStockDeVenta: '',
            CodigoUbicacionStockDeReposicion: '',
            VerificacionStockObligatoriaEnApertura: false,
            VerificacionStockObligatoriaEnCierre: false,
            FechaUltimaVerificacionStockApertura: '',
            FechaUltimaVerificacionStockCierre: '',
            PuntoVentaSePuedenModificarPrecios: false,
            PuntoVentaConTurno: false,
            UltimoTurnoAbierto: 0,
            FechaDeTicketEsFechaDeApertura: '',
            ImporteEfectivoEnCajaAviso: 0,
            ImporteEfectivoEnCajaCorte: 0,
            HoraDesdeLaCualSalteaPrimerTurno: 0,
            VerificacionStockSecundariaObligatoriaEnApertura: false,
            VerificacionStockSecundariaObligatoriaEnCierre: false,
            FechaUltimaVerificacionStockSecundariaApertura: '',
            FechaUltimaVerificacionStockSecundariaCierre: '',
            InformaCierres_NoInformaTickets: 0,
            VerificacionStockTerciariaObligatoriaEnApertura: false,
            VerificacionStockTerciariaObligatoriaEnCierre: false,
            FechaUltimaVerificacionStockTerciariaApertura: '',
            FechaUltimaVerificacionStockTerciariaCierre: '',
            UltimaVersionIngresada: '',
            UltimaVersionIngresadaNumerica: '',
            PasswordBonificaciones: '',
            HabilitacionRetiroFraccionado: false,
            HabilitacionTabDetalleBotones: false,
            HabilitacionTabDetalleListado: false,
            HabilitacionTabClientes: false,
            HabilitacionTabPago: false,
            HabilitacionTabImagenes: false,
            HabilitacionTabAdministracion: false,
            HabilitacionBotonRemitoTransferencia: false,
            HabilitacionBotonMerma: false,
            HabilitacionBotonConsumo: false,
            HabilitacionBotonCheque: false,
            HabilitacionControlesEnvio: false,
            HabilitacionControlesArticuloPorCodigo: false,
            HabilitacionBotonRemitoVenta: false,
            HabilitacionTabDetalleBotonesSecundario: false,
            PorcentajeDescuentoMaximo: 0,
            HabilitacionBotonRecepcion: false,
            HabilitacionTabProveedores: false,
            CodPOSExterno: '',
            CodigoAgrupacion: '',
            InterfazIRSA: '',
            CodigoCuentaFinancieraRappi: '',
            SiempreTicketFraccionado: false,
            TieneImpresoraFiscal: false,
            GeneraDocsVentaExcluidosDeHojaDeRuta: false,
            PermiteDocumentosAbiertos: false,
            DocumentosAbiertosSonMesas: false,
            SolicitaVendedorAlCerrarOperacion: false,
            VentasPVProveedorDelivery1: '',
            VentasPVProveedorDelivery2: '',
            VentasPVProveedorDelivery3: '',
            VentasPVProveedorDelivery4: '',
            VentasPVProveedorDelivery5: '',
            VentasPVProveedorDelivery6: '',
            VentasPVProveedorDelivery1Activo: false,
            VentasPVProveedorDelivery2Activo: false,
            VentasPVProveedorDelivery3Activo: false,
            VentasPVProveedorDelivery4Activo: false,
            VentasPVProveedorDelivery5Activo: false,
            VentasPVProveedorDelivery6Activo: false,
            VentasPVProveedorDelivery1CantidadDigitos: 0,
            VentasPVProveedorDelivery2CantidadDigitos: 0,
            VentasPVProveedorDelivery3CantidadDigitos: 0,
            VentasPVProveedorDelivery4CantidadDigitos: 0,
            VentasPVProveedorDelivery5CantidadDigitos: 0,
            VentasPVProveedorDelivery6CantidadDigitos: 0,
            VentasPVProveedorDelivery1CuentaFinanciera: '',
            VentasPVProveedorDelivery2CuentaFinanciera: '',
            VentasPVProveedorDelivery3CuentaFinanciera: '',
            VentasPVProveedorDelivery4CuentaFinanciera: '',
            VentasPVProveedorDelivery5CuentaFinanciera: '',
            VentasPVProveedorDelivery6CuentaFinanciera: '',
            VentasPVProveedorDelivery1ListaDePrecios: '',
            VentasPVProveedorDelivery2ListaDePrecios: '',
            VentasPVProveedorDelivery3ListaDePrecios: '',
            VentasPVProveedorDelivery4ListaDePrecios: '',
            VentasPVProveedorDelivery5ListaDePrecios: '',
            VentasPVProveedorDelivery6ListaDePrecios: '',
            TerminalParaControlDeExpedicion: '',
            HabilitacionTabReservas: false,
          })
        } else {
          setTituloBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setEsModificacion(true)

          const datosDocumento = await function_ABM_IMP_Terminales_Leer(props.Codigo.Codigo)
          setDatos(datosDocumento.data[0])

          if (datosDocumento.data[0]?.Logo) {
            let mimeType = "image/jpeg"; // Valor por defecto

            // Detectar el formato a partir del encabezado de la cadena Base64
            if (datosDocumento.data[0].Logo.startsWith("/9j/")) mimeType = "image/jpeg";
            else if (datosDocumento.data[0].Logo.startsWith("iVBOR")) mimeType = "image/png";
            else if (datosDocumento.data[0].Logo.startsWith("R0lGOD")) mimeType = "image/gif";

            const logoUrl = `data:${mimeType};base64,${datosDocumento.data[0].Logo}`;
            setImagenLogoPreview(logoUrl);
          }
        }
      } catch (error) {
        alert(error);
      }
    }
    getData();
  }, []);

  const validateForm = (e) => {
    e.component.validate();
  };

  return (
    <LVForm
      colCount={1}
      formData={datos}
      onContentReady={validateForm}
    >
      <TabbedItem>
        <TabPanelOptions deferRendering={false} />

        <Tab title="General" colCount={1}>
        
          <GroupItem>
            <SimpleItem dataField="CodigoTerminal" editorType="dxNumberBox" >
              <Label text="Código" />
              <RequiredRule message="Indicar el Código es obligatorio." />
            </SimpleItem>
            <SimpleItem dataField="Descripcion">
              <Label text="Descripción" />
              <RequiredRule message="Indicar la Descripción es obligatorio." />
            </SimpleItem>

            <SimpleItem>
              <Label text="Cargar Logo" />
              <input type="file" accept="image/*" onChange={handleImagenLogoChange} />
            </SimpleItem>

            {imagenLogoPreview && (
              <SimpleItem>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", marginTop: "10px" }}>
                  <img
                    src={imagenLogoPreview}
                    alt="Vista Previa"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "150px",
                      objectFit: "contain",
                    }}
                  />
                  <LVButtonAccion Texto={"GUARDAR LOGO"} onClick={handleOnClick_GuardarImagenLogo} />
                </div>
              </SimpleItem>
            )}

          </GroupItem>

          <GroupItem colCount={3}>

            <SimpleItem dataField="PasswordBonificaciones" >
              <Label text="Contraseña Bonificaciones" />
            </SimpleItem>

            <SimpleItem dataField="PorcentajeDescuentoMaximo" editorType="dxNumberBox" >
              <Label text="% Descuento Máximo" />
            </SimpleItem>

            <SimpleItem dataField="CodigoAgrupacion" >
              <Label text="Código Agrupación" />
            </SimpleItem>

            <SimpleItem dataField="SiempreTicketFraccionado" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    SiempreTicketFraccionado: e.value
                  }));
                }
              }}>
              <Label text="Siempre Ticket Fraccionado" />
            </SimpleItem>

            <SimpleItem dataField="TieneImpresoraFiscal" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    TieneImpresoraFiscal: e.value
                  }));
                }
              }}>
              <Label text="Tiene Impresora Fiscal" />
            </SimpleItem>

            <SimpleItem dataField="GeneraDocsVentaExcluidosDeHojaDeRuta" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    GeneraDocsVentaExcluidosDeHojaDeRuta: e.value
                  }));
                }
              }}>
              <Label text="Genera DocsVenta Excluidos de Hoja de Ruta" />
            </SimpleItem>

            <SimpleItem dataField="PermiteDocumentosAbiertos" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    PermiteDocumentosAbiertos: e.value
                  }));
                }
              }}>
              <Label text="Permite Documentos Abiertos" />
            </SimpleItem>

            <SimpleItem dataField="DocumentosAbiertosSonMesas" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    DocumentosAbiertosSonMesas: e.value
                  }));
                }
              }}>
              <Label text="Documentos Abiertos son Mesas" />
            </SimpleItem>

            <SimpleItem dataField="SolicitaVendedorAlCerrarOperacion" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    SolicitaVendedorAlCerrarOperacion: e.value
                  }));
                }
              }}>
              <Label text="Solicita Vendedor al Cerrar Operación" />
            </SimpleItem>

            <SimpleItem dataField="PuntoVentaSePuedenModificarPrecios" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    PuntoVentaSePuedenModificarPrecios: e.value
                  }));
                }
              }}>
              <Label text="Se pueden modificar Precios en P.V." />
            </SimpleItem>

            <SimpleItem dataField="PuntoVentaConTurno" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    PuntoVentaConTurno: e.value
                  }));
                }
              }}>
              <Label text="Punto de Venta con Turno" />
            </SimpleItem>

            <SimpleItem dataField="FechaDeTicketEsFechaDeApertura" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    FechaDeTicketEsFechaDeApertura: e.value
                  }));
                }
              }}>
              <Label text="Fecha de Ticket es Fecha de Apertura" />
            </SimpleItem>

            <SimpleItem dataField="InformaCierres_NoInformaTickets" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    InformaCierres_NoInformaTickets: e.value
                  }));
                }
              }}>
              <Label text="Informa Cierres (No Informa Tickets)" />
            </SimpleItem>

            <SimpleItem dataField="TerminalParaControlDeExpedicion" editorType="dxNumberBox">
              <Label text="Terminal para Control de Expedición" />
            </SimpleItem>

            <SimpleItem dataField="UltimoTurnoAbierto" editorType="dxNumberBox">
              <Label text="Último Turno Abierto" />
            </SimpleItem>

            <SimpleItem dataField="ImporteEfectivoEnCajaAviso" editorType="dxNumberBox">
              <Label text="Importe Efectivo en Caja - Aviso" />
            </SimpleItem>

            <SimpleItem dataField="ImporteEfectivoEnCajaCorte" editorType="dxNumberBox">
              <Label text="Importe Efectivo en Caja - Corte" />
            </SimpleItem>

            <SimpleItem dataField="HoraDesdeLaCualSalteaPrimerTurno" editorType="dxNumberBox">
              <Label text="Hora desde la cual saltea Primer Turno" />
            </SimpleItem>

          </GroupItem>

        </Tab>

        <Tab title="Propiedades" colCount={2}>

          <GroupItem caption="Cuentas Financieras">
            <SimpleItem dataField="CodigoCuentaFinancieraEfectivoCaja">
              <Label text="Efectivo Caja" />
            </SimpleItem>

            <SimpleItem dataField="CodigoCuentaFinancieraEfectivoRetiros" >
              <Label text="Efectivo Retiros" />
            </SimpleItem>

            <SimpleItem dataField="CodigoCuentaFinancieraRappi" >
              <Label text="Rappi" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Ubicaciones">
            <SimpleItem dataField="CodigoUbicacionStockDeVenta">
              <Label text="Stock de Venta" />
            </SimpleItem>

            <SimpleItem dataField="CodigoUbicacionStockDeReposicion" >
              <Label text="Stock de Reposición" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Versiones N4">
            <SimpleItem dataField="UltimaVersionIngresada">
              <Label text="Última Version Ingresada" />
            </SimpleItem>

            <SimpleItem dataField="UltimaVersionIngresadaNumerica" editorType="dxNumberBox" >
              <Label text="Última Version Ingresada Numérica" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="I.R.S.A.">
            <SimpleItem dataField="CodPOSExterno">
              <Label text="Cód. POS Externo" />
            </SimpleItem>
            <SimpleItem dataField="InterfazIRSA" >
              <Label text="Interfaz I.R.S.A." />
            </SimpleItem>
          </GroupItem>

        </Tab>

        <Tab title="Proveedores Delivery" colCount={3}>

          <GroupItem caption="Proveedor Delivery 1">

            <SimpleItem dataField="VentasPVProveedorDelivery1Activo" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    VentasPVProveedorDelivery1Activo: e.value
                  }));
                }
              }}>
              <Label text="Activo" />
            </SimpleItem>

            <SimpleItem dataField="VentasPVProveedorDelivery1" >
              <Label text="Nombre" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery1CuentaFinanciera">
              <Label text="Cuenta Financiera" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery1ListaDePrecios" >
              <Label text="Lista de Precios" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery1CantidadDigitos" editorType="dxNumberBox">
              <Label text="Dígitos" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Proveedor Delivery 2">

            <SimpleItem dataField="VentasPVProveedorDelivery2Activo" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    VentasPVProveedorDelivery2Activo: e.value
                  }));
                }
              }}>
              <Label text="Activo" />
            </SimpleItem>

            <SimpleItem dataField="VentasPVProveedorDelivery2" >
              <Label text="Nombre" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery2CuentaFinanciera">
              <Label text="Cuenta Financiera" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery2ListaDePrecios" >
              <Label text="Lista de Precios" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery2CantidadDigitos" editorType="dxNumberBox">
              <Label text="Dígitos" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Proveedor Delivery 3">

            <SimpleItem dataField="VentasPVProveedorDelivery3Activo" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    VentasPVProveedorDelivery3Activo: e.value
                  }));
                }
              }}>
              <Label text="Activo" />
            </SimpleItem>

            <SimpleItem dataField="VentasPVProveedorDelivery3" >
              <Label text="Nombre" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery3CuentaFinanciera">
              <Label text="Cuenta Financiera" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery3ListaDePrecios" >
              <Label text="Lista de Precios" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery3CantidadDigitos" editorType="dxNumberBox">
              <Label text="Dígitos" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Proveedor Delivery 4">

            <SimpleItem dataField="VentasPVProveedorDelivery4Activo" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    VentasPVProveedorDelivery4Activo: e.value
                  }));
                }
              }}>
              <Label text="Activo" />
            </SimpleItem>

            <SimpleItem dataField="VentasPVProveedorDelivery4" >
              <Label text="Nombre" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery4CuentaFinanciera">
              <Label text="Cuenta Financiera" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery4ListaDePrecios" >
              <Label text="Lista de Precios" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery4CantidadDigitos" editorType="dxNumberBox">
              <Label text="Dígitos" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Proveedor Delivery 5">

            <SimpleItem dataField="VentasPVProveedorDelivery5Activo" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    VentasPVProveedorDelivery5Activo: e.value
                  }));
                }
              }}>
              <Label text="Activo" />
            </SimpleItem>

            <SimpleItem dataField="VentasPVProveedorDelivery5" >
              <Label text="Nombre" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery5CuentaFinanciera">
              <Label text="Cuenta Financiera" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery5ListaDePrecios" >
              <Label text="Lista de Precios" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery5CantidadDigitos" editorType="dxNumberBox">
              <Label text="Dígitos" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Proveedor Delivery 6">

            <SimpleItem dataField="VentasPVProveedorDelivery6Activo" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    VentasPVProveedorDelivery6Activo: e.value
                  }));
                }
              }}>
              <Label text="Activo" />
            </SimpleItem>

            <SimpleItem dataField="VentasPVProveedorDelivery6" >
              <Label text="Nombre" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery6CuentaFinanciera">
              <Label text="Cuenta Financiera" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery6ListaDePrecios" >
              <Label text="Lista de Precios" />
            </SimpleItem>
            <SimpleItem dataField="VentasPVProveedorDelivery6CantidadDigitos" editorType="dxNumberBox" >
              <Label text="Dígitos" />
            </SimpleItem>
          </GroupItem>

        </Tab>

        <Tab title="Habilitaciones" colCount={1}>

          <GroupItem colCount={3}>

            <SimpleItem dataField="HabilitacionRetiroFraccionado" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionRetiroFraccionado: e.value
                  }));
                }
              }}>
              <Label text="Retiro Fraccionado" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionTabDetalleBotones" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionTabDetalleBotones: e.value
                  }));
                }
              }}>
              <Label text="Tab Detalle Botones" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionTabDetalleListado" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionTabDetalleListado: e.value
                  }));
                }
              }}>
              <Label text="Tab Detalle Listado" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionTabClientes" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionTabClientes: e.value
                  }));
                }
              }}>
              <Label text="Tab Clientes" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionTabPago" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionTabPago: e.value
                  }));
                }
              }}>
              <Label text="Tab Pago" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionTabImagenes" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionTabImagenes: e.value
                  }));
                }
              }}>
              <Label text="Tab Imagenes" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionTabAdministracion" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionTabAdministracion: e.value
                  }));
                }
              }}>
              <Label text="Tab Administración" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionTabDetalleBotonesSecundario" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionTabDetalleBotonesSecundario: e.value
                  }));
                }
              }}>
              <Label text="HabilitacionTabDetalleBotonesSecundario" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionTabProveedores" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionTabProveedores: e.value
                  }));
                }
              }}>
              <Label text="Tab Proveedores" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionTabReservas" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionTabReservas: e.value
                  }));
                }
              }}>
              <Label text="Tab Reservas" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionBotonRemitoTransferencia" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionBotonRemitoTransferencia: e.value
                  }));
                }
              }}>
              <Label text="Botón Remito Transferencia" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionBotonMerma" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionBotonMerma: e.value
                  }));
                }
              }}>
              <Label text="Botón Merma" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionBotonConsumo" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionBotonConsumo: e.value
                  }));
                }
              }}>
              <Label text="Botón Consumo" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionBotonCheque" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionBotonCheque: e.value
                  }));
                }
              }}>
              <Label text="Botón Cheque" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionBotonRemitoVenta" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionBotonRemitoVenta: e.value
                  }));
                }
              }}>
              <Label text="Botón Remito de Venta" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionBotonRecepcion" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionBotonRecepcion: e.value
                  }));
                }
              }}>
              <Label text="Botón Recepción" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionControlesEnvio" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionControlesEnvio: e.value
                  }));
                }
              }}>
              <Label text="Controles de Envío" />
            </SimpleItem>

            <SimpleItem dataField="HabilitacionControlesArticuloPorCodigo" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    HabilitacionControlesArticuloPorCodigo: e.value
                  }));
                }
              }}>
              <Label text="Controles Articulo por Código" />
            </SimpleItem>

          </GroupItem>

        </Tab>

        <Tab title="Aperturas y Cierres" colCount={1}>
          <GroupItem caption="Importes" colCount={4}>

            <SimpleItem dataField="VerificacionSaldoObligatoriaEnApertura" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    VerificacionSaldoObligatoriaEnApertura: e.value
                  }));
                }
              }}>
              <Label text="Verificación saldo en Apertura" />
            </SimpleItem>

            <SimpleItem dataField="VerificacionSaldoObligatoriaEnCierre" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    VerificacionSaldoObligatoriaEnCierre: e.value
                  }));
                }
              }}>
              <Label text="Verificación saldo en Cierre" />
            </SimpleItem>

            <SimpleItem dataField="FechaUltimaCargaSaldoApertura" editorType="dxDateBox" >
              <Label text="Fecha última Carga de Saldo Apertura" />
            </SimpleItem>

            <SimpleItem dataField="FechaUltimaCargaSaldoCierre" editorType="dxDateBox" >
              <Label text="Fecha última Carga de Saldo Cierre" />
            </SimpleItem>

            <SimpleItem dataField="ImporteUltimoSaldoAperturaEfectivo" editorType="dxNumberBox" >
              <Label text="Importe Último Saldo Apertura en Efectivo" />
            </SimpleItem>

            <SimpleItem dataField="ImporteFaltanteSaldoAperturaEfectivo" editorType="dxNumberBox">
              <Label text="Importe Faltante Saldo Apertura en Efectivo" />
            </SimpleItem>

            <SimpleItem dataField="ImporteSobranteSaldoAperturaEfectivo" editorType="dxNumberBox" >
              <Label text="Importe Sobrante Saldo Apertura en Efectivo" />
            </SimpleItem>

            <SimpleItem dataField="ImporteUltimoSaldoCierreEfectivo" editorType="dxNumberBox">
              <Label text="Importe Último Saldo Cierre en Efectivo" />
            </SimpleItem>

            <SimpleItem dataField="ImporteUltimoSaldoCierreCredito" editorType="dxNumberBox" >
              <Label text="Importe Último Saldo Cierre en Credito" />
            </SimpleItem>

            <SimpleItem dataField="ImporteUltimoSaldoCierreDebito" editorType="dxNumberBox">
              <Label text="Importe Último Saldo Cierre en Debito" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Stock"  colCount={3}>
          <GroupItem caption="Verificación 1">

            <SimpleItem dataField="VerificacionStockObligatoriaEnApertura" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    VerificacionStockObligatoriaEnApertura: e.value
                  }));
                }
              }}>
              <Label text="En Apertura" />
            </SimpleItem>

            <SimpleItem dataField="VerificacionStockObligatoriaEnCierre" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    VerificacionStockObligatoriaEnCierre: e.value
                  }));
                }
              }}>
              <Label text="En Cierre" />
            </SimpleItem>

            <SimpleItem dataField="FechaUltimaVerificacionStockApertura" editorType="dxDateBox" >
              <Label text="Fecha Última Verificación Stock Apertura" />
            </SimpleItem>

            <SimpleItem dataField="FechaUltimaVerificacionStockCierre" editorType="dxDateBox" >
              <Label text="Fecha Última Verificación Stock Cierre" />
            </SimpleItem>

          </GroupItem>

          <GroupItem caption="Verificación 2">

            <SimpleItem dataField="VerificacionStockSecundariaObligatoriaEnApertura" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    VerificacionStockSecundariaObligatoriaEnApertura: e.value
                  }));
                }
              }}>
              <Label text="En Apertura" />
            </SimpleItem>

            <SimpleItem dataField="VerificacionStockSecundariaObligatoriaEnCierre" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    VerificacionStockSecundariaObligatoriaEnCierre: e.value
                  }));
                }
              }}>
              <Label text="En Cierre" />
            </SimpleItem>

            <SimpleItem dataField="FechaUltimaVerificacionStockSecundariaApertura" editorType="dxDateBox" >
              <Label text="Fecha Última Verificación Stock Secundaria Apertura" />
            </SimpleItem>

            <SimpleItem dataField="FechaUltimaVerificacionStockSecundariaCierre" editorType="dxDateBox" >
              <Label text="Fecha Última Verificación Stock Secundaria Cierre" />
            </SimpleItem>

          </GroupItem>

          <GroupItem caption="Verificación 3">

            <SimpleItem dataField="VerificacionStockTerciariaObligatoriaEnApertura" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    VerificacionStockTerciariaObligatoriaEnApertura: e.value
                  }));
                }
              }}>
              <Label text="En Apertura" />
            </SimpleItem>

            <SimpleItem dataField="VerificacionStockTerciariaObligatoriaEnCierre" editorType="dxCheckBox"
              editorOptions={{
                onValueChanged: (e) => {
                  setDatos(prev => ({
                    ...prev,
                    VerificacionStockTerciariaObligatoriaEnCierre: e.value
                  }));
                }
              }}>
              <Label text="En Cierre" />
            </SimpleItem>

            <SimpleItem dataField="FechaUltimaVerificacionStockTerciariaApertura" editorType="dxDateBox" >
              <Label text="Fecha Última Verificación Stock Terciaria Apertura" />
            </SimpleItem>

            <SimpleItem dataField="FechaUltimaVerificacionStockTerciariaCierre" editorType="dxDateBox" >
              <Label text="Fecha Última Verificación Stock Terciaria Cierre" />
            </SimpleItem>

          </GroupItem>
          </GroupItem>
        </Tab>
      </TabbedItem>

      <ButtonItem horizontalAlignment="Center" colSpan={3}>
        <ButtonOptions onClick={handleOnClick_Guardar} type='success' useSubmitBehavior={true} text={TituloBoton} />
      </ButtonItem>
    </LVForm>
  );

}

export default ABM_IMP_Terminales;